import React from 'react';
import { Box } from '@mui/material';
import { useCustomGridFooter } from './useCustomGridFooter';
import { CustomGridFooterProps } from './types';

export const CustomGridFooter: React.FC<CustomGridFooterProps> = ({
  rowCount,
  isGroupingEnabled,
  groups,
  text,
}) => {
  const footerText = useCustomGridFooter({
    rowCount,
    isGroupingEnabled,
    groups,
    text,
  });

  return (
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        padding: '8px 16px',
        fontSize: '0.875rem',
        color: 'text.secondary',
      }}
    >
      {footerText}
    </Box>
  );
};
